module.exports = __webpack_public_path__ + "img/img9.3de4eb75.jpg";